import angular from "angular";
import kendo from "@progress/kendo-ui";
import "kendo.timezones";

import kendoDirectives from "../../shims/kendoDirectives";

import ngSanitize from "angular-sanitize";
import ngAria from "angular-aria";

import uiRouter from "@uirouter/angularjs";
import uiBootstrap from "angular-ui-bootstrap";

import uiRouterPreviousStateModule from "tbClient/services/PreviousStateService";
import TrackingEventSearchModuleConstants from "./Constants";

import Assert from "tbAssert";
import DependencyListBuilder from "../../utility/DependencyListBuilder";
import StringUtils from "tbClient/utility/StringUtils";

import UserInfoServiceModule from "../../services/UserInfoService";
import EncodedHtmlDecoderServiceModule from "../../services/EncodedHtmlDecoderService";
import EventReportSearchServiceModule from "../../services/TrackingEventReportSearchService";
import TrackingEventReportDataServiceModule from "../../services/TrackingEventReportDataService";
import SearchFilterConfigModule from "./SearchFilterConfig";
import EventTitleGridTemplateBuilderServiceModule from "../../services/EventTitleGridTemplateBuilder";
import MobileViewDetectorFactoryModule from "../../services/MobileViewDetectorService";
import FormatTimeZoneNameFilterModule from "../../filters/FormatTimeZoneNameFilter";
import EventFilterPanelModule from "../event-filter-panel/EventFilterPanel";
import EventFilterStoreServiceModule from "../../services/EventFilterStoreService";
import CalendarGlobalViewServiceModule from "../../services/CalendarGlobalViewService";

import EventTrackingReportDialogController from "../event-tracking-report-dialog/EventTrackingReportDialog";

import MessageQueue from "../../models/MessageQueue";

const mobileMaxWidth = 991;

const mSanitizeSvc = new WeakMap();
const mLogSvc = new WeakMap();
const mQSvc = new WeakMap();
const mTimeoutSvc = new WeakMap();
const mDocumentSvc = new WeakMap();
const mAnchorScrollSvc = new WeakMap();

const mUIRouterStateSvc = new WeakMap();
const mUIRouterPreviousStateSvc = new WeakMap();
const mUIRouterTransitionMgrSvc = new WeakMap();
const mUIBModalSvc = new WeakMap();

const mUserInfoSvc = new WeakMap();
const mEventReportSearchSvc = new WeakMap();
const mTrackingEventReportDataSvc = new WeakMap();
const mEncodedHtmlDecoderSvc = new WeakMap();
const mMobileViewDetectorSvc = new WeakMap();
const mEventFilterStoreSvc = new WeakMap();
const mCalendarGlobalViewSvc = new WeakMap();

const mInInit = new WeakMap();

const errorMessageType = "danger";
const defaultMessageTimeout = "undefined";
const mSearchErrorMessageQueue = new WeakMap();

const mCurrentSearchFilterConfig = new WeakMap();
const mFirstSearchSubmitted = new WeakMap();
const mShowSearchHelp = new WeakMap();
const mShowFilterPanel = new WeakMap();
const mFilterPanelInitialized = new WeakMap();
const mEnableFilters = new WeakMap();

const mCurrentStateParams = new WeakMap();
const mSearchCommandVal = new WeakMap();
const mCurrentSearchCommand = new WeakMap();


const mReportLoadingMessage = new WeakMap();

const mEventSearchDataSource = new WeakMap();
const mSearchGridEventTitleTemplate = new WeakMap();
const mEventSearchResultsGridOptions = new WeakMap();

const mTrackingEventReportsTable = new WeakMap();

const searchPageHeaderElementId = "tb-event-search-page-header";

function getSearchResultsGrid() {
    let searchResultsGrid = angular.element("#searchResultsGrid");
    let searchResultsGridWidget = searchResultsGrid.data("kendoGrid");

    return searchResultsGridWidget;
}

function getSearchResultsDataSource() {
    let searchResultsGridWidget = getSearchResultsGrid();
    let gridDataSource = searchResultsGridWidget.dataSource;

    return gridDataSource;
}


class TrackingEventSearchViewController {
    constructor($scope,
                $sanitize,
                $log,
                $q,
                $timeout,
                $document,
                $anchorScroll,
                $state,
                $transition$,
                $previousState,
                $transitions,
                $uibModal,
                UserInfoService,
                EventReportSearchService,
                TrackingEventReportData,
                EncodedHtmlDecoder,
                SearchFilterConfig,
                EventTitleGridTemplateBuilder,
                MobileViewDetector,
                EventFilterStore,
                CalendarGlobalViewService)
    {
        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Scope Service Dependency");
        Assert.StrictAssert($sanitize != null, "Assertion Failure: Missing Ng-Sanitize Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert($q != null, "Assertion Failure: Missing Q Service Dependency");
        Assert.StrictAssert($timeout != null, "Assertion Failure: Missing Timeout Service Dependency");
        Assert.StrictAssert($document != null, "Assertion Failure: Missing Document Service Dependency");
        Assert.StrictAssert($anchorScroll != null, "Assertion Failure: Missing Anchor Scroll Service Dependency");

        Assert.StrictAssert($state != null, "Assertion Failure: Missing UI Router State Service Dependency");
        Assert.StrictAssert($transition$ != null, "Assertion Failure: Missing UI Router State Parameters Dependency");
        Assert.StrictAssert($previousState != null, "Assertion Failure: Missing UI Router Previous State Service Dependency");
        Assert.StrictAssert($transitions != null, "Assertion Failure: Missing UI Router Transition Manager Service Dependency");
        Assert.StrictAssert($uibModal != null, "Assertion Failure: Missing UIB Modal Service Dependency");

        Assert.StrictAssert(UserInfoService != null, "Assertion Failure: Missing User Info Service Dependency");
        Assert.StrictAssert(EventReportSearchService != null, "Assertion Failure: Missing Event Report Search Service Dependency");
        Assert.StrictAssert(TrackingEventReportData != null, "Assertion Failure: Missing Tracking Event Report Data Service Dependency");
        Assert.StrictAssert(EncodedHtmlDecoder != null, "Assertion Failure: Missing Encoded Html Decoder Service Dependency");
        Assert.StrictAssert(SearchFilterConfig != null, "Assertion Failure: Missing Search Filter Configuration Dependency");

        Assert.StrictAssert(EventTitleGridTemplateBuilder != null, "Assertion Failure: Missing Event Title Grid Builder Service Dependency");
        Assert.StrictAssert(MobileViewDetector != null, "Assertion Failure: Missing Mobile View Detector Service Dependency");
        Assert.StrictAssert(EventFilterStore != null, "Assertion Failure: Missing Event Filter Store Service Dependency");
        Assert.StrictAssert(CalendarGlobalViewService != null, "Assertion Failure: Missing Global View Service Dependency");

        mInInit.set(this, true);

        mSanitizeSvc.set(this, $sanitize);
        mLogSvc.set(this, $log);
        mQSvc.set(this, $q);
        mTimeoutSvc.set(this, $timeout);
        mDocumentSvc.set(this, $document);
        mAnchorScrollSvc.set(this, $anchorScroll);
        mUIBModalSvc.set(this, $uibModal);
        mUIRouterStateSvc.set(this, $state);
        mUIRouterPreviousStateSvc.set(this, $previousState);
        mUIRouterTransitionMgrSvc.set(this, $transitions);
        mEventFilterStoreSvc.set(this, EventFilterStore);
        mCalendarGlobalViewSvc.set(this, CalendarGlobalViewService);

        mSearchErrorMessageQueue.set(this, new MessageQueue(errorMessageType, defaultMessageTimeout));

        mUserInfoSvc.set(this, UserInfoService);
        mEventReportSearchSvc.set(this, EventReportSearchService);
        mTrackingEventReportDataSvc.set(this, TrackingEventReportData);
        mEncodedHtmlDecoderSvc.set(this, EncodedHtmlDecoder);

        mFirstSearchSubmitted.set(this, false);

        mSearchCommandVal.set(this, "");
        mCurrentSearchCommand.set(this, null);
        mCurrentStateParams.set(this, {
            searchQuery: null,
            fromNavBar: null
        });

        mShowSearchHelp.set(this, false);
        mShowFilterPanel.set(this, false);
        mFilterPanelInitialized.set(this, false);

        mTrackingEventReportsTable.set(this, new Map());

        if (MobileViewDetector.mobileMaxWidth !== mobileMaxWidth) {
            MobileViewDetector.mobileMaxWidth = mobileMaxWidth;
        }
        mMobileViewDetectorSvc.set(this, MobileViewDetector); //Not Using New Because We're Calling Function Returned by Factory.

        mReportLoadingMessage.set(this, {
            isError: false,
            msg: "Loading Tracking Report"
        });

        mCurrentSearchFilterConfig.set(this, SearchFilterConfig(
            (searchFilter) => { this._changeCurrentSearchFilter(searchFilter); } //Not using new here because we're calling factory function.
        ));

        mSearchGridEventTitleTemplate.set(this, EventTitleGridTemplateBuilder.eventTitleTemplate);

        let eventSearchDataSourceParams = {
            transport: {
                read: (options) => {
                    let searchCommandStr = this.currentSearchCommand;
                    mEventReportSearchSvc.get(this)
                        .SearchReports(
                            searchCommandStr,
                            options.data.page,
                            options.data.pageSize,
                            options.data.filter,
                            options.data["sort"]
                        )
                        .then((response) => this._updateSearchPageState(searchCommandStr)
                            .then(() => {
                                options.success(response);
                            })
                        )
                        .catch((errorResponse) =>
                            mTimeoutSvc.get(this)(() => {
                                if (angular.isString(errorResponse)) {
                                    mSearchErrorMessageQueue.get(this)
                                        .publishMessage(errorResponse);
                                }
                                else {
                                    mSearchErrorMessageQueue.get(this)
                                        .publishMessage(
                                            "An unknown error occurred. Please check the log for details."
                                        );
                                    mLogSvc.get(this).error(errorResponse);
                                }
                                throw errorResponse;
                            }, 250))
                        .catch((errorResponse) => {
                            options.error(errorResponse);
                        });
                }
            },
            change: (e) => {
                angular.noop(e);
                return mTimeoutSvc.get(this)(
                    () => {
                        mAnchorScrollSvc.get(this)("tb-event-search-page-content-top");
                    },
                    0
                );
            },
            requestStart: (e) => {
                if ((mInInit.get(this) === true)) {
                    mLogSvc.get(this).debug("In request start: In Init is true");
                    if (e.type === "read") {
                        e.preventDefault(); // block the init read request, we'll trigger it when we change the filter.
                    }
                    // unset InInit before triggering data source read by changing the data source filter. Otherwise, potential loop.
                    mInInit.set(this, false);
                    this.applySearchResultsFilter(true);
                }
                else {
                    mLogSvc.get(this).debug("In request start: In Init is false");
                }
            },
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            schema: {
                model: {
                    id: "trackingEventId",
                    fields: {
                        trackingEventId: {
                            from: "trackingEventId",
                            type: "number"
                        },
                        displayTitle: { from: "eventDisplayName" },
                        start: { from: "startDate", type: "date" },
                        end: { from: "endDate", type: "date" },
                        eventTimezone: { from: "eventTimezone" },
                        statusName: { from: "statusName" },
                        locationName: { from: "locationName" },
                        locationAddress: { from: "locationAddress" },
                        locationCity: { from: "locationCity" },
                        locationStateName: { from: "locationState.shortName" },
                        eventTypes: {
                            from: "eventTypes",
                            parse: function(data) {
                                return data.map(function(et) {
                                    return et.eventTypeName;
                                }).join(", ");
                            }
                        }
                    }
                },
                data: (serverData) => serverData.eventData,
                total: "totalItems"
            },
            pageSize: 25
        };

        mEventSearchDataSource.set(this, new kendo.data.DataSource(eventSearchDataSourceParams));

        mEventSearchResultsGridOptions.set(this, {
            dataSource: mEventSearchDataSource.get(this),
            columns: [
                {
                    field: "displayTitle",
                    title: "Name",
                    headerAttributes: { "ng-non-bindable": true },
                    template: mSearchGridEventTitleTemplate.get(this),
                    sortable: true
                },
                {
                    field: "startDate",
                    title: "Start",
                    headerAttributes: { "ng-non-bindable": true },
                    template: "{{dataItem.start | date : 'M/d/yyyy, h:mm a'}}",
                    sortable: true
                },
                {
                    field: "eventTimezone",
                    title: "Time Zone",
                    headerAttributes: { "ng-non-bindable": true },
                    template: "{{dataItem.eventTimezone | tbFormatTZName }}",
                    sortable: false
                },
                {
                    field: "statusName",
                    title: "Status",
                    headerAttributes: { "ng-non-bindable": true },
                    sortable: true
                },
                {
                    field: "locationName",
                    title: "Location Name",
                    headerAttributes: { "ng-non-bindable": true },
                    sortable: false
                },
                {
                    field: "locationCity",
                    title: "City",
                    headerAttributes: { "ng-non-bindable": true },
                    sortable: false
                },
                {
                    field: "locationStateName",
                    title: "State",
                    headerAttributes: { "ng-non-bindable": true },
                    sortable: true
                },
                {
                    field: "eventTypes",
                    title: "Event Types",
                    headerAttributes: { "ng-non-bindable": true },
                    sortable: false
                }
            ],
            noRecords: {
                template: "<h6>NO RESULTS FOUND (OR NONE MATCHED YOUR FILTER)</h6>"
            },
            scrollable: false,
            sortable: {
                allowUnsort: true,
                mode: "single"
            },
            pageable: true,
            allowCopy: true,
            detailInit: (e) => { this._gridDetailInitHandler(e); },
            detailExpand: (e) => { this._gridDetailExpandHandler(e); }
        });

        this._updateSearchParameterState($transition$);

        const removeSearchPageUrlChangeHook = $transitions.onSuccess(
            {to: TrackingEventSearchModuleConstants.rootStateName},
            (transition) => {
                let changedParams = transition._changedParams();
                if ((transition.options().source === "url") && changedParams && changedParams.length > 0) {
                    $log.debug("Finished state change started by change in url. Syncing search.", {
                        changes: changedParams
                    });

                    this._updateSearchParameterState(transition);
                    this._updateSearchFromStateParameters();
                }
            });

        $scope.$on("$destroy", () => {
            removeSearchPageUrlChangeHook();
        });

        $scope.$watch(
            () => CalendarGlobalViewService.getCurrentView(),
            (newGlobalView, oldGlobalView) => {
                if (newGlobalView != null && (oldGlobalView == null || newGlobalView.name !== oldGlobalView.name)) {
                    $log.debug("Global view changed: re-applying search results filter");
                    this.applySearchResultsFilter(true);
                }
            }
        );
    }

    $onInit() {
        const searchPageHeaderId = `#${searchPageHeaderElementId}`;
        mAnchorScrollSvc.get(this).yOffset = angular.element(searchPageHeaderId);

        this._updateSearchFromStateParameters();
    }

    get searchErrorMessages() {
        return mSearchErrorMessageQueue.get(this).messages;
    }

    get firstSearchSubmitted() {
        return mFirstSearchSubmitted.get(this);
    }

    get searchCommandVal() {
        return mSearchCommandVal.get(this);
    }

    set searchCommandVal(updatedSearchCommand) {
        mSearchCommandVal.set(this, updatedSearchCommand);
    }

    get currentSearchCommand() {
        return mCurrentSearchCommand.get(this);
    }

    get showSearchHelp() {
        return mShowSearchHelp.get(this);
    }

    get showFilterPanel() {
        return mShowFilterPanel.get(this);
    }

    get filterPanelInitialized() {
        return mFilterPanelInitialized.get(this);
    }

    get enableFilters() {
        return mEnableFilters.get(this);
    }

    get currentSearchFilterConfig() {
        return mCurrentSearchFilterConfig.get(this);
    }

    get reportLoadingMessage() {
        return mReportLoadingMessage.get(this);
    }

    get eventSearchResultsGridOptions() {
        return mEventSearchResultsGridOptions.get(this);
    }

    get eventFilterData() {
        return mEventFilterStoreSvc.get(this).searchEventFilter;
    }

    get shouldShowEventStatusFilters() {
        const shouldShowFilters = mUserInfoSvc.get(this).hasInternalUserRights;
        return (shouldShowFilters);
    }

    _updateSearchParameterState(currentTransition) {
        const stateParams = currentTransition.params();
        const currentStateParams = mCurrentStateParams.get(this);
        currentStateParams.searchQuery = stateParams.searchQuery;
        currentStateParams.fromNavBar = stateParams.fromNavBar;
    }

    _updateSearchFromStateParameters() {
        const stateParams = mCurrentStateParams.get(this);
        const providedSearchCommand = stateParams.searchQuery;
        if ((angular.isString(providedSearchCommand)) &&
            (providedSearchCommand.length > 0))
        {
            this.searchCommandVal = providedSearchCommand;
            this.runSearch();
        }
    }

    _changeCurrentSearchFilter(searchFilter) {
        mTimeoutSvc.get(this)(() => {
            let searchResultsGridDataSource = getSearchResultsDataSource();
            searchResultsGridDataSource.filter(searchFilter);
        },0);
    }

    _gridDetailInitHandler(e) {
        if (!(mMobileViewDetectorSvc.get(this).isViewMobile)) {
            if (e != null) {
                let dataItem = e.data;
                if (dataItem != null) {
                    this.getTrackingReport(dataItem.trackingEventId);
                }
            }
        }
    }

    _gridDetailExpandHandler(e) {
        if (mMobileViewDetectorSvc.get(this).isViewMobile) {
            this.reportLoadingMessage.isError = false;
            this.reportLoadingMessage.msg = "Loading Tracking Report...";

            let dataGrid = e.sender;
            let currentRow = e.masterRow;
            let currentDataItem = dataGrid.dataItem(currentRow);

            if (currentDataItem != null) {
                this.showTrackingReport(currentDataItem)
                    .then(
                        () => {
                            mTimeoutSvc.get(this)(() => {
                                dataGrid.collapseRow(currentRow);
                            }, 0);
                        },
                        (errorMsg) => {
                            mLogSvc.get(this).error(errorMsg);
                            mTimeoutSvc.get(this)(() => {
                                dataGrid.collapseRow(currentRow);
                            }, 3000);
                        }
                    );
            }
        }
    }

    _updateSearchPageState(updatedSearchString) {
        const prevStateSvc = mUIRouterPreviousStateSvc.get(this);
        const logSvc = mLogSvc.get(this);
        const currentStateParams = mCurrentStateParams.get(this);

        if (!StringUtils.IsNullOrWhitespace(updatedSearchString)) {
            logSvc.debug("Updating Search UI Router state");
            const shouldReplace = (currentStateParams.fromNavBar ? "replace" : true);
            return mUIRouterStateSvc.get(this).go(
                TrackingEventSearchModuleConstants.rootStateName,
                {searchQuery: updatedSearchString, fromNavBar: null},
                {location: shouldReplace}
            )
            .then(() => {
                logSvc.debug("Completed search ui router state update via transition.");
                prevStateSvc.forget(TrackingEventSearchModuleConstants.prevStateLabel);
                currentStateParams.searchQuery = updatedSearchString;
                currentStateParams.fromNavBar = null;
             });
        }
        else {
            return Promise.resolve(true);
        }
    }

    removeErrorMessage(msgIdx) {
        mSearchErrorMessageQueue.get(this).removeMessageAtIdx(msgIdx);
    }

    toggleSearchHelp(e) {
        if (e != null) {
            e.preventDefault();
        }

        mShowSearchHelp.set(this, !(mShowSearchHelp.get(this)));
    }

    toggleFilterPanel(e) {
        if (e != null) {
            e.preventDefault();
        }

        if ((this.showFilterPanel === false) && (this.filterPanelInitialized !== true)) {
            mFilterPanelInitialized.set(this, true);
            mShowFilterPanel.set(this, true);
        }
        else {
            mShowFilterPanel.set(this, !(mShowFilterPanel.get(this)));
        }
    }

    showTrackingReport(eventData) {

        if (eventData == null) {
            throw new TypeError("Show Tracking Report: Missing Event Data");
        }

        if (!Number.isInteger(eventData.trackingEventId)) {
            throw new TypeError("Show Report: Invalid Event Id");
        }

        let canViewTrackingReport = false;
        try {
            canViewTrackingReport = eventData.trackingStatus.isReported;
        }
        catch (e) {
            canViewTrackingReport = false;
        }

        if (canViewTrackingReport !== true) {
            this.reportLoadingMessage.isError = true;
            this.reportLoadingMessage.msg = "Cannot show tracking report for an unreported event";
            return mQSvc.get(this).reject("Cannot show tracking report for an unreported event");
        }

        let currentEventId = eventData.trackingEventId;
        let currentEventDisplayName = eventData.displayTitle;

        let modalInstance = mUIBModalSvc.get(this).open({
            animation: true,
            controller: EventTrackingReportDialogController,
            template: EventTrackingReportDialogController.template,
            controllerAs: EventTrackingReportDialogController.controllerAs,
            backdropClass: "tbIn",
            windowClass: "tbIn",
            size: "lg",
            resolve: {
                trackingReportData: () => {
                    let trackingEventId = currentEventId;
                    return mTrackingEventReportDataSvc.get(this)
                        .get({eventId: trackingEventId})
                        .$promise
                        .then(
                            (eventReportData) => {
                                let decodedReport = mSanitizeSvc.get(this)(
                                    mEncodedHtmlDecoderSvc.get(this)
                                        .decode(eventReportData.result.report));
                                mTrackingEventReportsTable.get(this)
                                    .set(trackingEventId, decodedReport);
                                return eventReportData.result;
                            },
                            (errorMsg) => {
                                mLogSvc.get(this).error(errorMsg);
                            }
                        );
                },
                trackingEventName: (() => currentEventDisplayName)
            }
        });

        let modalReturnPromise = modalInstance.result.then(
            () => {
                mLogSvc.get(this).debug("Done!");
            },
            (errorMsg) => {
                if (errorMsg === "cancel") {
                    mLogSvc.get(this)
                        .debug("Report dialog cancelled");
                }
                else {
                    mLogSvc.get(this).warn("Problem!");
                }
            }
        );

        return modalReturnPromise;
    }

    getTrackingReportFromTable(eventId) {
        if (!Number.isInteger(eventId)) {
            return undefined;
        }

        if (!(mMobileViewDetectorSvc.get(this).isViewMobile)) {
            return mTrackingEventReportsTable.get(this).get(eventId);
        }
        else {
            return undefined;
        }
    }

    getTrackingReport(eventId) {
        if (!Number.isInteger(eventId)) { return "Invalid Event Id"; }

        let trackingReportContent = mTrackingEventReportsTable.get(this).get(eventId);

        if (angular.isUndefined(trackingReportContent)) {
            mTrackingEventReportDataSvc.get(this)
                .get({eventId: eventId})
                .$promise
                .then(
                    (reportDataResponse) => {
                        let decodedReport = mSanitizeSvc.get(this)(
                            mEncodedHtmlDecoderSvc.get(this)
                                .decode(reportDataResponse.result.report)
                        );
                        mTrackingEventReportsTable.get(this).set(eventId, decodedReport);
                    },
                    (errorResponse) => {
                        mLogSvc.get(this).error("Error retrieving tracking report ", errorResponse);
                        mTimeoutSvc.get(this)(() => {
                            mSearchErrorMessageQueue.get(this)
                                .publishMessage(
                                    "Error retrieving tracking report. Please check the log for details."
                                );
                        }, 0);
                    }
                );
        }
    }

    runSearch(e) {
        if (e != null) {
            e.preventDefault();
        }

        mSearchErrorMessageQueue.get(this).clearMessages();

        if ((angular.isString(this.searchCommandVal)) &&
            (this.searchCommandVal.length > 0))
        {
            mCurrentSearchCommand.set(this, this.searchCommandVal);
            if (this.firstSearchSubmitted === false) {
                mFirstSearchSubmitted.set(this, true);
            }
            mShowSearchHelp.set(this, false);
        }
        else {
            mCurrentSearchCommand.set(this, null);
        }
    }

    applySearchResultsFilter(doNotToggleFilterPanel) {

        mLogSvc.get(this).debug(`In Apply Search Results Filter. Do Not Toggle Filter Panel Is ${doNotToggleFilterPanel === true ? "true" : "false" }`);
        const eventFilterStore = mEventFilterStoreSvc.get(this);
        const globalViewSvc = mCalendarGlobalViewSvc.get(this);

        const searchFilter = eventFilterStore.searchEventFilter;
        const currentGlobalView = globalViewSvc.getCurrentView();
        const searchDataSourceFilter = searchFilter.dataSourceFilter(currentGlobalView.rule);

        this.currentSearchFilterConfig.currentFilter = searchDataSourceFilter;
        if (doNotToggleFilterPanel !== true) {
            this.toggleFilterPanel();
        }
        eventFilterStore.saveSearchEventFilter();
    }

}

TrackingEventSearchViewController.$inject = [
    "$scope",
    "$sanitize",
    "$log",
    "$q",
    "$timeout",
    "$document",
    "$anchorScroll",
    "$state",
    "$transition$",
    "$previousState",
    "$transitions",
    "$uibModal",
    "UserInfoService",
    "EventReportSearchService",
    "TrackingEventReportData",
    "EncodedHtmlDecoder",
    "SearchFilterConfig",
    "EventTitleGridTemplateBuilder",
    "MobileViewDetector",
    "EventFilterStore",
    "CalendarGlobalViewService"
];

TrackingEventSearchViewController.dependencies = DependencyListBuilder([
        EventTrackingReportDialogController.dependencies,
        [
            ngSanitize,
            ngAria,
            uiRouter,
            uiRouterPreviousStateModule,
            uiBootstrap,
            kendoDirectives,
            UserInfoServiceModule,
            EventReportSearchServiceModule,
            TrackingEventReportDataServiceModule,
            EncodedHtmlDecoderServiceModule,
            SearchFilterConfigModule,
            EventTitleGridTemplateBuilderServiceModule,
            MobileViewDetectorFactoryModule,
            FormatTimeZoneNameFilterModule,
            EventFilterPanelModule,
            EventFilterStoreServiceModule,
            CalendarGlobalViewServiceModule
        ]
    ]
);

TrackingEventSearchViewController.template = require("./TrackingEventSearch.tpl.html");

TrackingEventSearchViewController.controllerAs = "eventSearchView";

export default TrackingEventSearchViewController;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-search/TrackingEventSearchViewController.js
// module id = SnxU
// module chunks = 1